import { render, staticRenderFns } from "./VideoCallPage.vue?vue&type=template&id=67bf59a0&scoped=true"
import script from "./VideoCallPage.vue?vue&type=script&lang=js"
export * from "./VideoCallPage.vue?vue&type=script&lang=js"
import style0 from "./VideoCallPage.vue?vue&type=style&index=0&id=67bf59a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bf59a0",
  null
  
)

export default component.exports